$('.js-slider').slick({
  centerMode: true,
  centerPadding: 'calc( calc(100% - 128rem) / 2 )',
  slidesToShow: 1,
  autoplay: true,
  arrows: true,
  dots: true,
  autoplaySpeed: 6000,
  responsive: [
    {
      breakpoint: 1025,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: 'calc(calc(calc(19 / 375) * 100vw) / 1.5)',
        arrows: false,
        dots: true,
      }
    },
    {
      breakpoint: 1201,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0',
        arrows: true,
        dots: true,
      }
    }
  ]
});
